export default __webpack_public_path__ + "static/media/j.cfa6cdad.mp3";